import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import './App.scss';
import Card from "./Card";
import ThreeColumnCard from "./ThreeColumnCard";
import { CardStyleType } from "../type/feConfig";
import LoadMore from "../components/loadMore/LoadMore";
import RankPoiItem from '../components/rank-poi-item';
/**
 * 根据样式类型渲染相应的卡片组件
 */
const renderCardList = (cardList, styleType, texReportData, query, systemInfo, poiIdListString, poiIdUrlExtraParamsString, topTagText, topTagShowCount) => {
    const commonProps = {
        texReportData,
        query,
        systemInfo,
        poiIdListString: poiIdListString !== null && poiIdListString !== void 0 ? poiIdListString : '',
        poiIdUrlExtraParamsString: poiIdUrlExtraParamsString !== null && poiIdUrlExtraParamsString !== void 0 ? poiIdUrlExtraParamsString : '',
        topTagText,
        topTagShowCount
    };
    if (styleType === CardStyleType.ThreeColumn) {
        return <View className="three-column-container">
        {cardList.map((cardProps, index) => <ThreeColumnCard key={`three-col-${index}`} {...cardProps} {...commonProps} cardIndex={index}/>)}
      </View>;
    }
    if (styleType === CardStyleType.RankPoi) {
        return <View>
        {cardList.map((cardProps, index) => <View style={{
                    marginBottom: '18rpx'
                }}>
            <RankPoiItem key={`rank-poi-${index}`} {...cardProps} {...commonProps} cardIndex={index}/>
          </View>)}
      </View>;
    }
    // 单列样式
    return cardList.map((cardProps, index) => <Card key={`single-col-${index}`} {...cardProps} {...commonProps} cardIndex={index}/>);
};
function App(props) {
    return <View className="app-container" style={{
            backgroundColor: props.backgroundColor
        }}>
      {renderCardList(props.cardList, props.styleType, props.texReportData, props.query, props.systemInfo, props.poiIdListString, props.poiIdUrlExtraParamsString, props.topTagText, props.topTagShowCount)}
      {props.showLoadMore && <LoadMore color={props.loadMoreButtonColor} icon={String(props.loadMoreDownArrowIconImg)} onClick={props.loadMore} styleType={props.styleType}/>}
    </View>;
}
export default memo(App);
